<template>
  <loader v-if="loadingPrices" />
  <div v-else>
    <h5 @click="toggleCollapse">
      {{ i18n.t('/Totalen/SubtotaalInclCorrecties') }}
    </h5>
    <quote-list-block v-if="!isCollapsed">
      <template #body>
        <li class="row">
          <div class="title">{{ i18n.t('/Totalen/ExclBtwBpm') }}</div>
          <div class="price price-incl">
            {{ i18n.n(price.Excl, 'currency') }}
          </div>
        </li>
        <li class="row">
          <div class="title">{{ i18n.t('/Totalen/BtwHoog') }}</div>
          <div class="price price-incl">
            {{ i18n.n(price.Btw, 'currency') }}
          </div>
        </li>
        <li class="row">
          <div class="title">{{ i18n.t('/Totalen/BpmBedrag') }}</div>
          <div class="price price-incl">
            {{ i18n.n(price.BPM, 'currency') }}
          </div>
        </li>
        <li class="row total">
          <div class="title">{{ i18n.t('/Totalen/Subtotaal') }}</div>
          <div class="price price-incl">
            {{ i18n.n(price.Incl, 'currency') }}
          </div>
        </li>
      </template>
    </quote-list-block>
  </div>
</template>

<script>
import QuoteListBlock from '@/components/generic/presentational/molecules/quoteListBlock/QuoteListBlock.vue'
import StoreConnector from '@/helpers/StoreConnector'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'

export default {
  components: {
    QuoteListBlock,
    Loader,
  },
  data() {
    return {
      price: null,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      isCollapsed: true,
    }
  },
  computed: {
    loadingPrices() {
      return !this.price
    },
  },
  created() {
    StoreConnector.get('quote/totalPrice', (data) => {
      this.price = data
    })
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.row) {
  grid-template-columns: auto 6em;
  grid-template-areas: 'title price-incl';
}
</style>
